import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"
import clsx from "clsx"

const Slider = React.forwardRef(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={clsx(
      "relative flex w-full touch-none select-none items-center",
      className
    )}
    {...props}
  >
    <SliderPrimitive.Track className="relative h-1 w-full grow overflow-hidden rounded-full bg-[#3C3C432E]">
      <SliderPrimitive.Range className="absolute h-full bg-[#2E9BFF]" />
    </SliderPrimitive.Track>
        <SliderPrimitive.Thumb style={{
        boxShadow: '0px 6px 13px 0px #0000001F',        
    }} className="block border border-[#3C3C432E] h-7 w-7 rounded-full bg-white transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50" />
  </SliderPrimitive.Root>
))
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
